import { useSettings } from "@/context/SettingsContext";
import { useI18n } from "@/i18n/I18nContext";
import { MessageCircle } from "lucide-react";

export function WhatsAppButton({ floating = true }) {
  const { settings } = useSettings();
  const { t } = useI18n();
  const number = settings?.whatsapp || "50760000000";
  const href = `https://wa.me/${number}`;

  if (!floating) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-inline-button"
        className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
      >
        <MessageCircle className="h-4 w-4" /> WhatsApp
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={t("whatsapp")}
      className="fixed bottom-24 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 md:bottom-6"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
